function hoverBtnColorFill(el, color) {
  el.querySelector(".text").style.cssText = "color: " + color + " !important;";
  el.querySelector(".icon_fill").style.cssText =
    "fill: " + color + " !important;";
}
function hoverSvgEl(el, color) {
  el.style.cssText = "fill: " + color + " !important;";
}
function hoverSubMenuSvg(el, color) {
  // let logo = el.querySelector(".icon");
  let arrow = el.querySelector(".arrow_link_more");
  if(arrow != null) {
    // logo.style.cssText = "fill: " + color + " !important;";
    arrow.style.cssText = "fill: " + color + " !important;";
  }
}
//HOVER FOR BTNS ON MAIN PAGE BLOCK PRODUCTS
function setColorBlocks(el, color) {
  el.querySelector(".text").style.cssText = "color: " + color + ";";
  let lightIcon = el.querySelector(".play_light");
  let darkIcon = el.querySelector(".play_dark");
  let styleLight = window.getComputedStyle(lightIcon, null);
  el.querySelector(".icon_fill").style.cssText = "fill: " + color + ";";
  if (styleLight.display == "block") {
    lightIcon.querySelector(".icon_fill").style.cssText =
      "fill: " + color + ";";
  } else {
    darkIcon.querySelector(".icon_fill").style.cssText = "fill: " + color + ";";
  }
}
function defaultColorBlocks(el, color, colorEvenBlock) {
  // console.log(el);
  let lightIcon = el.querySelector(".play_light");
  let darkIcon = el.querySelector(".play_dark");
  let styleLight = window.getComputedStyle(lightIcon, null);
  // console.log(styleLight.display);

  if (styleLight.display == "block") {
    el.querySelector(".text").style.cssText = "color: " + color + ";";
    lightIcon.querySelector(".icon_fill").style.cssText =
      "fill: " + color + ";";
  } else {
    el.querySelector(".text").style.cssText = "color: " + colorEvenBlock + ";";
    darkIcon.querySelector(".icon_fill").style.cssText =
      "fill: " + colorEvenBlock + ";";
  }
}
//HOVER FOR BTNS ON MAIN PAGE BLOCK PRODUCTS
// HOVER FOR SECOND MENU LINK
function hoverColorHeader(el, color) {
  el.querySelector("a").style.cssText = "color: " + color + ";";
}
// END HOVER FOR SECOND MENU LINK

// HOVER FOR SECOND SUBMENU LINK
function hoverColorEl(el, color) {
  el.style.cssText = "color: " + color + ";";
}
// END HOVER FOR SECOND SUBMENU LINK
// HOVER FOR SECOND MENU DESCRIPTION ITEM, WHEN MOUSE ON SUBMENU
function hoverColorForHeader(el, color) {
  el.previousElementSibling.querySelector("a").style.cssText =
    "color: " + color + ";";
}
// HOVER FOR SECOND MENU DESCRIPTION ITEM, WHEN MOUSE ON SUBMENU

function hoverBlackBtn(el, colorBg) {
  // el.style.cssText = "background-color: " + colorBg + ";";
  el.style.backgroundColor = colorBg;
}

function hoverBtnTerm(el, backgroundHover, colorHover) {
  el.style.cssText =
    "background-color: " + backgroundHover + ";" + "color: " + colorHover + ";";
}
